import { Modal, Button, Row, Col } from "react-bootstrap";
import aboutImg from "../assets/img/about-img.png";

const AboutModal = ({ show, handleClose }) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="dark-modal"
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
        <Button variant="light" className="custom-close" onClick={handleClose}>
          X
        </Button>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={3}>
            <img src={aboutImg} alt="About me" className="about-image" />
          </Col>
          <Col md={9}>
            <h2 className="mb-3">About Me</h2>
            <p>
              I'm an experienced Fullstack Developer located in West Texas,
              passionate about all aspects of software development. With a
              strong focus on implementation, I specialize in JavaScript, HTML,
              CSS, React, PostgreSQL, and have been expanding my skills with
              Django and Python for work. I have a background in responsive web
              design and building RESTful APIs. One of my passions outside of
              software development is exploring and embracing different
              cultures.
            </p>
            <p>
              As an Iranian-American, I have a deep connection to my Persian
              heritage. I'm always practicing speaking, reading, and writing the
              Persian language because not only is it a part of my identity, but
              I find the Persian culture to be incredibly beautiful and
              fascinating. It's a way for me to honor my roots and stay
              connected to my heritage.
            </p>
            <p>
              Beyond coding, I find joy in various hobbies and interests. You
              can often find me cycling, enjoying nature, reading, listening
              to podcasts, creating content, and indulging in great shows.
            </p>
            <p>
              I'm incredibly ambitious and constantly striving to improve my
              skills. I embrace challenges and take risks to push myself further
              in my coding journey. I'm excited about the possibilities that lie
              ahead and where my passion for software development and language
              learning will lead me.
            </p>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" lassName="custom-button" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AboutModal;
